package com.milta.core.localization.translations.bg

import com.milta.core.localization.OcrScanStrings

internal val OcrScan = OcrScanStrings(
    scanTitle = "Сканиране на документ",
    reviewTitle = "Проверка на данните",
    fileSentSuffix = "изпратено току-що",
    analysingTitle = "Прочитане на документа…",
    analysingSubtitle = "Откриваме доставките от снимката. Отнема само няколко секунди.",
    deliveriesDetectedSuffix = "открити доставки",
    toCompleteSuffix = "за попълване",
    reviewHint = "Попълнете отбелязаните доставки, преди да ги добавите към маршрута",
    addressMissingWarning = "Липсващ адрес",
    nameMissingWarning = "Липсващо име",
    recipientMissingPlaceholder = "Получателят не е разпознат",
    phoneNotDetectedNote = "Телефонът не е разпознат — не блокира добавянето",
    deadlineLabelPrefix = "Краен час",
    completeLinkLabel = "Попълни",
    addToRouteButtonPrefix = "Добави към маршрута",
    correctionRecipientLabel = "Получател",
    correctionAddressLabel = "Адрес",
    correctionPhoneLabel = "Телефон",
    correctionDeadlineLabel = "Краен час",
    unreadableTitle = "Нечетлива снимка.",
    unreadableMessage = "Не открихме нито една доставка на това изображение — направете нова, добре центрирана и добре осветена снимка.",
    retakePhotoButton = "Направи нова снимка",
    manualEntryButton = "Въведи ръчно",
    rateLimitTitle = "Извършени са твърде много скорошни сканирания.",
    rateLimitMessage = "Опитайте отново малко по-късно или попълнете тази доставка ръчно междувременно.",
    rateLimitRetakeUnavailableLabel = "Направи нова снимка — временно недостъпно",
)
